/** レイヤー切替スライド 1 フェーズ（exit / enter）。LayerSlideNumber.scss の $layer-slide-dur と同期 */
export const LAYER_SLIDE_MS = 300;
